import { render, staticRenderFns } from "./RoleDialog.vue?vue&type=template&id=76e3d3ec&scoped=true&"
import script from "./RoleDialog.vue?vue&type=script&lang=js&"
export * from "./RoleDialog.vue?vue&type=script&lang=js&"
import style0 from "./RoleDialog.vue?vue&type=style&index=0&id=76e3d3ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e3d3ec",
  null
  
)

export default component.exports